import React from 'react'
import sadhna from '../assets/images/sadhna.png';
export default function TYVNavbar() {
    return (
        <div className='navbar'>
            <div className='navbar-container' style={{ borderRight: "1px solid #CEDCEE" }}> TYV </div>
            <div className='navbar-container' style={{ borderLeft: "1px solid #CEDCEE" }}><img src={sadhna} alt="sadhan" /></div>
        </div>
    )
}